var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bell_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-bell_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bell_svg__st0",
    d: "M22 16.4h-2.3V8.2C19.7 4 16.3.5 12 .5S4.3 4 4.3 8.2v8.2H2c-.5 0-1 .4-1 1 0 .5.5 1 1 1h20c.5 0 1-.5 1-1s-.5-1-1-1zM6.3 8.2c0-3.1 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7v8.2H6.3V8.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bell_svg__st0",
    d: "M12 23.4c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm0-5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z",
    opacity: 0.5
  })));
}

export default SvgIconBell;